import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import * as React from "react";
import { useTranslation } from "react-i18next";
import "./PrwcDataTableBasic.scss";

const PrwcDataTableBasic = (props: any) => {
  const {
    data,
    columns,
    // noOfRows = CoreConstants.Data.table.paginator.rows,
    // rowsPerPageOptions = CoreConstants.Data.table.paginator.rowsPerPageOptions,
    paginator = false,
    ...restProps
  } = props;
  const { t } = useTranslation();

  return (
    <div className="prw-datatable-basic">
      <DataTable
        value={data}
        paginator={paginator}
        // rows={noOfRows}
        // rowsPerPageOptions={rowsPerPageOptions}
        {...restProps}
      >
        {columns &&
          columns.map((column: any) => (
            <Column
              key={column.field}
              field={column.field}
              header={t(column.headerLabelKey)}
              body={(props: any) =>
                column["bodyTemplate"](
                  column.field === "action"
                    ? props
                    : props[column.templateArgument ?? column.field]
                )
              }
              style={{ padding: "0.5rem" }}
              className={column.className}
              editor={
                column["editor"]
                  ? (props: any) => column["editor"](props, column.field)
                  : undefined
              }
            ></Column>
          ))}
      </DataTable>
    </div>
  );
};

export default PrwcDataTableBasic;
